<template>
    <div class="wrap">
        <div class="sub-title">Our case</div>
        <h2>{{ $t('from.case') }}</h2>
        <div class="service-box">
            <div class="service-item" v-for="(item, index) in srcList" :key="index">
                <img class="image" :src="item.url" @click="handleToPage(item.path)">
                <div class="service-title">{{ item.title }}</div>
            </div>
        </div>
    </div>
</template>
<script>
export default ({
    props: {
        language: {
            type: String,
            default: 'zh'
        }
    },
    data() {
        return {
            srcList: [
                {
                    url: 'http://47.97.102.116:8001/case01.png', title: '虾青素-β-乳球蛋白复合物分子动力学模拟', path: 'http://47.97.102.116:8001/01.docx'
                },
                {
                    url: 'http://47.97.102.116:8001/case02.png', title: 'NDFA13-PHB2 蛋白对接及分子动力学模拟', path: 'http://47.97.102.116:8001/02.docx'
                },
                {
                    url: 'http://47.97.102.116:8001/13.png', title: '蛋白-纳米球对接及分析', path: 'http://47.97.102.116:8001/03.docx'
                },
                {
                    url: 'http://47.97.102.116:8001/case04.png', title: '肝糖-RANK-RANKL 复合物分子动力学模拟', path: 'http://47.97.102.116:8001/04.docx'
                },
                {
                    url: 'http://47.97.102.116:8001/12.png', title: '长方体永磁铁磁通量计算', path: 'http://47.97.102.116:8001/05.docx'
                },
                {
                    url: 'http://47.97.102.116:8001/case06.png', title: '心磷脂密度分布估计', path: 'http://47.97.102.116:8001/06.docx'
                },
            ],
        }
    },
    watch: {
        language(newValue, oldValue) {
            console.log(oldValue, newValue)
            if (newValue == 'zh') {
                this.srcList = [
                    {
                        url: 'http://47.97.102.116:8001/case01.png',
                        title: '虾青素-β-乳球蛋白复合物分子动力学模拟', path: 'http://47.97.102.116:8001/01.docx'
                    },
                    {
                        url: 'http://47.97.102.116:8001/case02.png',
                        title: 'NDFA13-PHB2 蛋白对接及分子动力学模拟', path: 'http://47.97.102.116:8001/02.docx'
                    },
                    {
                        url: 'http://47.97.102.116:8001/13.png',
                        title: '蛋白-纳米球对接及分析', path: 'http://47.97.102.116:8001/03.docx'
                    },
                    {
                        url: 'http://47.97.102.116:8001/case04.png',
                        title: '肝糖-RANK-RANKL 复合物分子动力学模拟', path: 'http://47.97.102.116:8001/04.docx'
                    },
                    {
                        url: 'http://47.97.102.116:8001/12.png',
                        title: '长方体永磁铁磁通量计算', path: 'http://47.97.102.116:8001/05.docx'
                    },
                    {
                        url: 'http://47.97.102.116:8001/case06.png',
                        title: '心磷脂密度分布估计', path: 'http://47.97.102.116:8001/06.docx'
                    },
                ]
            } else {
                this.srcList = [
                    {
                        url: 'http://47.97.102.116:8001/case01.png',
                        title: 'Project Report - Astaxanthin', path: 'http://47.97.102.116:8001/01.docx'
                    },
                    {
                        url: 'http://47.97.102.116:8001/case02.png',
                        title: 'Protein-Protein Docking and MD for NDFA13-PHB2 Complex', path: 'http://47.97.102.116:8001/02.docx'
                    },
                    {
                        url: 'http://47.97.102.116:8001/13.png',
                        title: 'Protein-Nanosphere Docking and Analysis', path: 'http://47.97.102.116:8001/03.docx'
                    },
                    {
                        url: 'http://47.97.102.116:8001/case04.png',
                        title: 'MD of Heparin-RANKL-RANK ', path: 'http://47.97.102.116:8001/04.docx'
                    },
                    {
                        url: 'http://47.97.102.116:8001/12.png',
                        title: 'Magnetic Flux  Calculation of Rectangular Permanent Magnet', path: 'http://47.97.102.116:8001/05.docx'
                    },
                    {
                        url: 'http://47.97.102.116:8001/case06.png',
                        title: 'Evaluation of Cardiolipin Distribution', path: 'http://47.97.102.116:8001/06.docx'
                    },
                ]
            }
        }
    },
    methods: {
        handleToPage(url) {
            this.$emit('handleToPage', url)
        },
    }
})
</script>
<style scoped lang="scss">
@media only screen and (max-width: 750px) {
    .wrap {
        background-color: #fff;
        padding: 0 20px 20px 20px;
        box-sizing: border-box;

        .service-box {
            display: flex;
            flex-wrap: wrap;
            margin-top: 20px;

            .service-item {
                width: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                flex-wrap: wrap;

                .image {
                    width: 80%;
                    height: 130px;
                    border-radius: 6px;
                    transition: transform 0.5s ease-in-out;
                    transform: scale(1);
                    box-shadow: 10px 10px 0px 1px rgba(0, 0, 0, 0.07);
                }

                .image:hover {
                    transform: scale(1.1);
                }

                .service-title {
                    width: 60%;
                    text-align: center;
                    font-weight: bold;
                    font-size: 14px;
                    margin: 20px;
                    box-sizing: border-box;
                }
            }
        }
    }
}

@media only screen and (min-width: 751px) {
    .wrap {
        background-color: #fff;
        padding: 0 60px 60px 60px;
        box-sizing: border-box;

        .service-box {
            display: flex;
            flex-wrap: wrap;
            margin-top: 20px;

            .service-item {
                width: 33%;
                display: flex;
                flex-direction: column;
                align-items: center;

                .image {
                    width: 80%;
                    height: 260px;
                    border-radius: 6px;
                    transition: transform 0.5s ease-in-out;
                    transform: scale(1);
                    box-shadow: 10px 10px 0px 1px rgba(0, 0, 0, 0.07);
                }

                .image:hover {
                    transform: scale(1.1);
                }

                .service-title {
                    width: 60%;
                    text-align: center;
                    font-weight: bold;
                    font-size: 20px;
                    margin: 30px;
                    box-sizing: border-box;
                }
            }
        }
    }
}
</style>